import React from "react";
import SubscribeWithCouponForm from "../../forms/subscribe/form-coupon";
import { evaluateSubscriptionString } from "../../../util/subscription/subscriptions";
import { assemblePriceString, RedeemState } from "./util";
import { createSubscriptionForm } from "../../../util/subscription/subscribe";
import { removeSubscriptionInfoNextDateFromCache } from "../../../services/monsum/subscription/set-subscription-info";
var CodeRedeemSubscribe = function CodeRedeemSubscribe(_ref) {
    var checkResponse = _ref.checkResponse, setRedeemState = _ref.setRedeemState, setSubscriptionResult = _ref.setSubscriptionResult;
    var article = checkResponse.assignedArticles[0];
    var onSubmit = function onSubmit(values, _ref2) {
        var setSubmitting = _ref2.setSubmitting;
        setSubmitting(true);
        var subscribeData = {
            agb: values.legal.agb,
            city: values.customer.city,
            country: values.customer.country,
            duration: article.duration,
            email: values.customer.email,
            firstName: values.customer.firstName,
            lastName: values.customer.lastName,
            newsletter: values.newsletter.newsletter,
            zipcode: values.customer.postalCode,
            privacy: values.legal.privacy,
            salutation: values.customer.salutation,
            address: values.customer.street,
            subscriptionType: article.type,
            payment: {
                method: values.payment_method.method,
                bankAccountOwner: values.payment_method.account_owner,
                bankName: values.payment_method.bank,
                bankBIC: values.payment_method.bic,
                bankIBAN: values.payment_method.iban,
                paymentToken: values.payment_method.stripe_token
            },
            code: checkResponse.code
        };
        createSubscriptionForm(subscribeData).then(function (result) {
            if (result.data && result.data.success) {
                onSubmitSuccess(result.data);
            }
            else {
                console.error("Subscription failed - result:", result);
                onSubmitError();
            }
        }).catch(function (err) {
            console.error("Error code:", err.code);
            console.error("Error message:", err.message); // Firebase Functions specific error properties
            if (err.details) {
                console.error("HTTP Status:", err.details.status);
                console.error("HTTP Status Text:", err.details.statusText);
            }
            onSubmitError();
        });
        var onSubmitSuccess = function onSubmitSuccess(result) {
            removeSubscriptionInfoNextDateFromCache();
            setRedeemState(RedeemState.RESULT);
            setSubscriptionResult(result);
            setSubmitting(false);
        };
        var onSubmitError = function onSubmitError() {
            setRedeemState(RedeemState.RESULT);
            setSubmitting(false);
        };
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h1", {
        className: "text-5xl font-light leading-tight pl-8 pb-8"
    }, "Gleich geschafft!", /*#__PURE__*/ React.createElement("br", null), " Wir ben\xF6tigen nur noch ein paar Informationen von Ihnen."), /*#__PURE__*/ React.createElement("div", {
        className: "text-center content-text"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-12"
    }, /*#__PURE__*/ React.createElement("div", null, "Mit Ihrem Code ", /*#__PURE__*/ React.createElement("code", null, checkResponse.code), " erhalten Sie:"), /*#__PURE__*/ React.createElement("div", {
        className: "font-medium text-2xl mt-2"
    }, evaluateSubscriptionString(article.type, article.duration)), /*#__PURE__*/ React.createElement("div", {
        className: "my-2"
    }, "f\xFCr"), /*#__PURE__*/ React.createElement("div", {
        className: "font-medium text-2xl text-makroOrange"
    }, assemblePriceString(checkResponse)), /*#__PURE__*/ React.createElement("small", {
        className: "block mt-3"
    }, "Danach verl\xE4ngert sich das Abonnement zum normalen Preis.")), /*#__PURE__*/ React.createElement(SubscribeWithCouponForm, {
        onSubmit: onSubmit,
        assignedArticle: article
    })));
};
export default CodeRedeemSubscribe;
